export const TEXT = {
  TRACKING_MESSAGE: {id: 'mylk.nba.ps.message.tracking'},
  TRACKING_NUMBER: {id: 'mylk.nba.tracking.number'},
  DELIVERY_ADDRESS: {id: 'mylk.nba.tracking.delivery.adress'},
};
